import { Prompt, PicLink, EventBanner, Quicklink, EventResources, ScrollReset} from './obj.js'

import post1 from './img/training/MAPS @ Night Poster 1 (2).webp'
import post2 from './img/training/MAPS @ Night Poster 1 (3).webp'
import post3 from './img/training/MAPS @ Night Poster 1 (5).webp'
import post4 from './img/training/MAPS @ Night Poster 1 (7).webp'

import location from './icons/mdi_location.svg'
import spcpa from './icons/SPCPA_white.png'
import codeforces from './icons/simple-icons_codeforces.svg'

export default function Training(){
    return (<>
        <main className = "eventpage">
            <ScrollReset/>
            <EventBanner>Contest<br/>Training</EventBanner>
            <section className= "twocol">
                <div className = 'twobytwo'>
                    <PicLink src = {post1}></PicLink>
                    <PicLink src = {post2}></PicLink>
                    <PicLink src = {post3}></PicLink>
                    <PicLink src = {post4}></PicLink>
                </div>
                <Prompt text = "Training >>">
                    If you want to compete in national and internationally recognised programming competitions, contest training presents an opportunity to practise and level up. These sessions present a mix of content and competition practice, focussing on more advanced topics and data structures.                     <br></br>
                    <br></br>
                    We also discuss competition strategy and teamwork skills to ensure your optimal performance in competitions such as ICPC or SPPC.
                </Prompt>

            </section>
            <section className= "twocol">


                <EventResources>
                    <Quicklink src = {location} path = '/contest-training'>Training location</Quicklink>
                    <Quicklink src = {spcpa} path = 'https://prog4fun.csse.canterbury.ac.nz/'>SPAR Judge</Quicklink>
                    <Quicklink src = {codeforces} path = 'https://codeforces.com/'>Codeforces</Quicklink>
                    <Quicklink src = {spcpa} path = 'https://sppcontests.org/'>SPCPA</Quicklink>

                </EventResources>
            </section>

        </main>
    </>)
}